import { connect } from 'react-redux';
import InsuranceReport from 'components/reports/InsuranceReports';
import {
  fetchInsuranceReportGeneralData,
  fetchInsuranceReportFolderData,
} from 'data/reports/Reports.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      fetchingGeneralData: state.reports.fetchingReportGeneralData,
      generalData: state.reports.reportGeneralData,

      fetchingFolderData: state.reports.fetchingReportFolderData,
      folderData: state.reports.reportFolderData,
    },
    state,
    'experts',
    'partTypes',
    'regions',
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchGeneralData: opts => dispatch(fetchInsuranceReportGeneralData(opts)),
    fetchFolderData: opts => dispatch(fetchInsuranceReportFolderData(opts)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InsuranceReport);
